import type { Size, TypographyVariant, TextAlign } from "./types";

export const SIZES = ["md", "lg"] as const;
export const DEFAULT_SIZE = "md" satisfies Size;

export const TYPOGRAPHY_VARIANTS = ["bodyS", "bodyM"] as const;
export const DEFAULT_TYPOGRAPHY_VARIANT = "bodyS" satisfies TypographyVariant;

export const TEXT_ALIGN_OPTIONS = ["left", "center"] as const;
export const DEFAULT_TEXT_ALIGN = "left" satisfies TextAlign;
